export const membershipNotes = [
  ["01", "Nikola reads", "Move explanations and coaching suggestions grounded in the games you actually played."],
  ["02", "Your archive", "Games, analysis, and training patterns stay in one continuous record of your chess."],
  ["03", "On your terms", "Manage or cancel your membership from this page whenever you need to."],
] as const;
